export const routes = [
  {
    path: '/',
    name: 'root',
    component: () => import('/Users/hail/work/base/apps/lcms/src/pages/index.vue'),
    children: [
      {
        path: ':workspaceId',
        /* internal name: '//[workspaceId]' */
        /* no component */
        children: [
          {
            path: 'billing',
            name: 'billing',
            component: () => import('/Users/hail/work/base/apps/lcms/src/pages/index/[workspaceId]/billing.vue'),
            /* no children */
            meta: {
              "breadcrumb": "Billing",
              "layout": "Sidebar"
            }
          },
          {
            path: 'orders',
            /* internal name: '//[workspaceId]/orders' */
            /* no component */
            children: [
              {
                path: '',
                name: 'orders',
                component: () => import('/Users/hail/work/base/apps/lcms/src/pages/index/[workspaceId]/orders/index.vue'),
                /* no children */
                meta: {
                  "breadcrumb": "Orders",
                  "layout": "Sidebar"
                }
              },
              {
                path: ':action',
                name: 'order',
                component: () => import('/Users/hail/work/base/apps/lcms/src/pages/index/[workspaceId]/orders/[action].vue'),
                props: true,
                /* no children */
                meta: {
                  "breadcrumb": "Order"
                }
              }
            ],
          },
          {
            path: 'projects',
            /* internal name: '//[workspaceId]/projects' */
            /* no component */
            children: [
              {
                path: ':projectId',
                /* internal name: '//[workspaceId]/projects/[projectId]' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'repositories',
                    component: () => import('/Users/hail/work/base/apps/lcms/src/pages/index/[workspaceId]/projects/[projectId]/index.vue'),
                    /* no children */
                    meta: {
                      "breadcrumb": "Repositories",
                      "layout": "Sidebar"
                    }
                  },
                  {
                    path: ':repositoryId',
                    /* internal name: '//[workspaceId]/projects/[projectId]/[repositoryId]' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//[workspaceId]/projects/[projectId]/[repositoryId]/',
                        component: () => import('/Users/hail/work/base/apps/lcms/src/pages/index/[workspaceId]/projects/[projectId]/[repositoryId]/index.vue'),
                        /* no children */
                      },
                      {
                        path: 'mapping',
                        name: '//[workspaceId]/projects/[projectId]/[repositoryId]/mapping',
                        component: () => import('/Users/hail/work/base/apps/lcms/src/pages/index/[workspaceId]/projects/[projectId]/[repositoryId]/mapping.vue'),
                        /* no children */
                      },
                      {
                        path: 'repo',
                        name: 'contents',
                        component: () => import('/Users/hail/work/base/apps/lcms/src/pages/index/[workspaceId]/projects/[projectId]/[repositoryId]/repo.vue'),
                        /* no children */
                        meta: {
                          "breadcrumb": "Contents"
                        }
                      },
                      {
                        path: 'token-list',
                        name: '//[workspaceId]/projects/[projectId]/[repositoryId]/token-list',
                        component: () => import('/Users/hail/work/base/apps/lcms/src/pages/index/[workspaceId]/projects/[projectId]/[repositoryId]/token-list.vue'),
                        /* no children */
                      }
                    ],
                  }
                ],
              },
              {
                path: 'index-old',
                name: 'projects',
                component: () => import('/Users/hail/work/base/apps/lcms/src/pages/index/[workspaceId]/projects/index-old.vue'),
                /* no children */
                meta: {
                  "breadcrumb": "Projects",
                  "layout": "Sidebar"
                }
              }
            ],
          }
        ],
      },
      {
        path: 'inbox',
        name: 'inbox',
        component: () => import('/Users/hail/work/base/apps/lcms/src/pages/index/inbox.vue'),
        /* no children */
        meta: {
          "breadcrumb": "Inbox",
          "layout": "Sidebar"
        }
      }
    ],
  },
  {
    path: '/:all(.*)',
    name: '404',
    component: () => import('/Users/hail/work/base/apps/lcms/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/create-workspace',
    name: 'create-workspace',
    component: () => import('/Users/hail/work/base/apps/lcms/src/pages/create-workspace.vue'),
    /* no children */
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('/Users/hail/work/base/apps/lcms/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/oauth-callback',
    name: '/oauth-callback',
    component: () => import('/Users/hail/work/base/apps/lcms/src/pages/oauth-callback.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

